var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRrDesktopRightEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 563,
    viewBox: "0 0 224 563",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter0_f_8_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.813 399.011C77.1829 343.809 140.985 182.692 179.464 109.033C268.051 111.001 217.549 130.936 241.271 205.202C264.994 279.468 332.995 269.597 364.84 323.189C396.685 376.781 297.113 430.833 272.039 443.47C246.964 456.108 195.601 468.013 129.813 399.011Z",
    fill: "#B22134"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8_209",
    x: 0.856079,
    y: 0.0332336,
    width: 479.203,
    height: 562.134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 54.5,
    result: "effect1_foregroundBlur_8_209"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRrDesktopRightEllipse);
export default __webpack_public_path__ + "static/media/RR-desktopRightEllipse.b71f8d8c75afe20347db82d66c8549ba.svg";
export { ForwardRef as ReactComponent };